export default "__VITE_ASSET__DAVUzoZI__"